import { render, staticRenderFns } from "./aceEditorPhp.vue?vue&type=template&id=4387a75c"
import script from "./aceEditorPhp.vue?vue&type=script&lang=js"
export * from "./aceEditorPhp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports